module.exports = __webpack_public_path__ + "static/media/bed.8c2376bb.png";